import { call, put, takeEvery } from 'redux-saga/effects';
import { DOWNLOAD_LEGAL_DOCUMENT_API_URL } from '../../../../constants/ApiUrlConstants';
import { postBlobApiRequest } from '../../../../features/axiosClient';
import toast from 'react-hot-toast';
import { downloadLegalDocumentFailure, downloadLegalDocumentSuccess } from '../actions/settingsActions';
import { DOWNLOAD_LEGAL_DOCUMENT_REQUEST } from '../../../../constants/ActionNameConstants';

function* downloadLegalDocumentSaga(action) {
  try {
    const { audioFileId, template, fileName, CGAType } = action.payload;
    const response = yield call(
      postBlobApiRequest,
      DOWNLOAD_LEGAL_DOCUMENT_API_URL,
      {},
      {
        audioFileId,
        template,
        cgaType: CGAType,
      },
    );

    try {
      const text = yield response.data.text();
      const json = JSON.parse(text);

      if ('success' in json && !json.success) {
        const errorMessage =
        json?.errorMessage ||
        json?.exceptionMessage ||
          'Failed to download file';

        yield put(downloadLegalDocumentFailure(errorMessage));
        toast.error(errorMessage);
        return;
      }
    } catch {
    }

    const mimeType = response.headers['content-type'] || 'application/octet-stream';

    const blob = new Blob([response.data], { type: mimeType });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    yield put(downloadLegalDocumentSuccess());
    toast.success('File downloaded successfully');
  } catch (error) {
    yield put(downloadLegalDocumentFailure(error));
    toast.error('Failed to download file');
  }
}

export function* watchDownloadLegalDocument() {
  yield takeEvery(DOWNLOAD_LEGAL_DOCUMENT_REQUEST, downloadLegalDocumentSaga);
}
